if($('.type-detail').length){
    $(document).ready(function () {
        var textFriends = '#kamarádi'
        if($('table.detail-parameters tbody tr th').text().includes(textFriends)){
            var apiUrl = "https://friends.shopcode.cz/api-variantImagese.php";
            var section = "earmy";
            var codes = [];
            $('table.detail-parameters tbody tr').each(function () {
                var $th = $(this).find('th span.row-header-label');
                var $td = $(this).find('td');
                var headerText = $th.text().trim();
                var friendCode = $td.text().trim();
                if (headerText.toLowerCase().includes('#kamarádi')) {
                    $(this).hide();
                    if (friendCode && !codes.includes(friendCode)) {
                        codes.push(friendCode.toString());
                    }
                }
            });
            if (codes.length === 0) {
                console.warn("Žádné hodnoty "+textFriends+" nebyly nalezeny.");
                return;
            }
            function escapeHtmlAttr(text) {
                return text
                    .replace(/&/g, "&amp;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;");
            }

            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                  section: section,
                  codes: getShoptetDataLayer('product').codes[0].code
                },
                dataType: "json",
                success: function(response) {
                    $(".p-info-wrapper").prepend('<div class="friendsSection"><div class="h3">Barevná varianta</div><div class="inner"></div></div>');
                     response.forEach(function (item) {
            
                         for (var i = 0; i < item.related.length; i++) {
                            var itemProduct = item.related[i];
                            var nameEscaped = escapeHtmlAttr(itemProduct.name);
                            if (document.location.href === itemProduct.url) {
                                var customClass = 'active'
                             }
                             else{
                                 var customClass = '' 
                             }
                            var detailHtml = `
                            <div class="friend ${customClass} show-tooltip" data-title="${nameEscaped}" data-original-title="${nameEscaped}">
                                <div class="p">
                                    <div class="image">
                                        <a href="${itemProduct.url}">
                                            <img src="${itemProduct.image}" alt="${nameEscaped}">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            `;
                            $(".p-info-wrapper .friendsSection .inner").append(detailHtml);
                          
                            
                        }
                     });
                  
               
                },
                error: function(xhr, status, error) {
                  console.error("Chyba při volání API:", error);
                }
                }).done(function(){
                    initTooltips();
                });
          }

            /*$.ajax({
                url: apiUrl + "?section=" + section + "&codes=" + codes.join(","),
                type: "GET",
                dataType: "json",
                success: function (response) {
                    console.log(response.length)
                    $(".p-info-wrapper").prepend('<div class="friendsSection"><div class="h3">Barevná varianta</div><div class="inner"></div></div>');
                   var usedUrls = new Set();
                   console.log(response)
                    response.forEach(function (item) {
                        var itemUrl =item.url.split('?variantId')[0]
                        if (document.location.pathname === itemUrl) {
                           var customClass = 'active'
                        }
                        else{
                            var customClass = '' 
                        }
                        
                       
                        
                        if (!usedUrls.has(itemUrl)) {
                            usedUrls.add(itemUrl);
                            var detailHtml = `
                            <div class="friend ${customClass} show-tooltip" data-title="${item.name.split('-')[0]}" data-original-title="${item.name.split('-')[0]}">
                                <div class="p">
                                    <div class="image">
                                        <a href="${itemUrl}">
                                            <img src="${item.image.replace('/orig/', '/detail/').split('.cz')[1]}" alt="${item.name.split('-')[0]}">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            `;
                            $(".p-info-wrapper .friendsSection .inner").append(detailHtml);
                        }
                    });
                },
                error: function (xhr, status, error) {
                    console.error("Chyba při načítání API:", status, error);
                }
            }).done(function(){
                initTooltips();
            });*/
       /* }*/
        
    });

    $('.p-info-wrapper').append($('.p-detail-inner-header').clone());
    $('.p-image').append($('.p-detail-info .flags'));
    $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });
    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === 'Zvolte variantu'){
            $(this).text('Dle varianty')
        }
    })
    
    $('.p-info-wrapper .delivery-time').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="stockLine"></div>')
    if($('.p-info-wrapper .delivery-time').length>0){
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html())
    }
    else{
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .shipping-options'))
       
    }
  
    $('.p-info-wrapper').append('<div class="customCart"><div class="inner"></div></div>');
    $('.customCart .inner').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))


    if($('.variant-list').length){
        if(!$('#simple-variants').length){
            if($('.variant-list, .surcharge-list').length>0){
                $('.variant-list select, .surcharge-list select').each(function(){
                    if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                        var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                    }
                    else{
                        listTootip = ''
                    }
                    var optionLength = $(this).find('option').length
                    var data_parameter_id = $(this).data('parameter-id')
                    var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                    html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                    $(this).find('option').each(function(){
                        var data_value = $(this).attr('value')
                        if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                            if ($.isNumeric($(this).val())) {
                                var textsplit = $(this).text().split('+')
                                html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                                html_var += '<div class="text">'
                                if(typeof textsplit[1] === 'undefined'){
                                    html_var += textsplit[0]
                                }
                                else{
                                    html_var += textsplit[0]+' (+'+textsplit[1]+')'
                                }
                              
                                if(listTootip !== ''){
                                    if(textsplit[1] !== '0 Kč'){
                                        html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                    }
                                }
                                html_var += '</div>'
                                html_var += '</div>'
                            }
                        }
                        else{
                            if ($.isNumeric($(this).val())) {
                                var textsplit = $(this).text().split('+')
                                html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                                html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                                html_var += '</div>'
                            }
                        }
                        
                    })
                    html_var += '</div>'
                    html_var += '</div>'
                    $(this).after(html_var)
                    $(this).closest('.variant-list select, .surcharge-list select').hide()
                   $(this).closest('.variant-list span, .surcharge-list span').hide()
                  
                })
        
                var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
                for (var parentKey in necessaryVariantData) {
                    if (necessaryVariantData.hasOwnProperty(parentKey)) {
                        var variant = necessaryVariantData[parentKey];
                        $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).attr('data-notSouldOut', variant.isNotSoldOut)
                    
                    }
                }
                
            }
        }
        $(document).ready(function(){
            $(".custom-variant-wrap").each(function() {
                var $variants = $(this).find("div.variant");
                if ($variants.length === 1) {
                 $variants.addClass("active");
                }
              });
            var urlParams = new URLSearchParams(window.location.search);
            var parameterValueId = urlParams.get("parameterValueId");
            var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
            if ($divToHighlight.length > 0) {
                $divToHighlight.addClass("active");
            }
        })
        
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
}